import * as amplitude from '@amplitude/analytics-browser';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import ReactionsManager from 'hb-react/frontoffice/components/Reactions';
import useNavigatorShare from 'hb-react/shared/hooks/useNavigatorShare';
import { getSharedContentType } from 'hb-react/shared/utils/amplitude/getSharedContentType';

const Reactions = ({ file, reactions }) => {
  const {
    initialLikes: likes,
    initialTotalComments: totalComments,
    isLoadingLikes = false,
    isLoadingComments = false,
    comments,
    onLikeCallback,
    onCommentCallback,
    ...restReactions
  } = reactions;

  // Triggers the like event
  const handleLike = useCallback(
    (likes) => {
      if (onLikeCallback) {
        onLikeCallback(likes, file);
      }
    },
    [onLikeCallback, file],
  );

  // triggers the comment event
  const handleComment = useCallback(
    (newTotalComments, newComments) => {
      if (onCommentCallback) {
        onCommentCallback(newTotalComments, newComments);
      }
    },
    [onCommentCallback],
  );

  const shareFileOrPostUrl = file?.sharePostUrl
    ? file?.sharePostUrl
    : `${window.location.origin}${window.location.pathname}`;

  const { handleShare, shareUrl } = useNavigatorShare({
    data: {
      text: file?.name,
      url: shareFileOrPostUrl,
    },
    onShare: () => {
      amplitude.track(
        `Reactions|${getSharedContentType(file.file_type)}}Shared`,
      );
    },
  });

  if (
    !file ||
    !Object.keys(file).length ||
    isLoadingLikes ||
    isLoadingComments ||
    !likes
  ) {
    return null;
  }

  return (
    <ReactionsManager
      initialLikes={likes}
      comments={comments}
      initialTotalComments={totalComments}
      id={file.id}
      onLikeCallback={handleLike}
      onCommentCallback={handleComment}
      handleShareButton={handleShare}
      shareUrl={shareUrl}
      sharedContent={file}
      {...restReactions}
    />
  );
};

Reactions.propTypes = {
  file: PropTypes.object,
  reactions: PropTypes.object,
};

Reactions.defaultProps = {
  reactions: {},
};

export default Reactions;
